import ChatbotForm from "features/Chatbot";

const ChatbotPage = () => {
  return <ChatbotForm />;
};

export default ChatbotPage;
